export default "__VITE_ASSET__BKbc68WT__"